export const plural = (count, singular, plural = null) => {
    let result = singular;
    if (count != 1) {
        if (plural === null || plural === "") {
            result += "s";
        } else {
            result = plural;
        }
    }

    return result;
};

export const generateUniqueString = () => {
    return String(Date.now().toString(32) + Math.random().toString(16)).replace(/\./g, "");
};

export const hideElements = (selector) => {
    let elements = typeof selector === "string" ? document.querySelectorAll(selector) : selector;
    if (elements.length > 0) {
        elements.forEach((element) => {
            hide(element);
        });
    }
};

export const hide = (selector, isImportant = false) => {
    let element = typeof selector === "string" ? document.querySelector(selector) : selector;
    if (element) {
        element.classList.add(`${isImportant ? "!" : ""}tw-hidden`);
    }
};
export const show = (selector, isImportant = false) => {
    let element = typeof selector === "string" ? document.querySelector(selector) : selector;
    if (element) {
        element.classList.remove(`${isImportant ? "!" : ""}tw-hidden`);
        element.classList.remove(`is-hidden`);
    }
};
export const simulateClick = (elem) => {
    // Create our event (with options)
    let evt;
    if (document.createEvent) {
        // To create a mouse event , first we need to create an event and then initialize it.
        evt = document.createEvent("MouseEvent");
        evt.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    } else {
        evt = new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
        });
    }
    elem.dispatchEvent(evt);
};
/**
 * Get height from element without margin and padding
 * @param element
 * @param withoutExtraSpace
 * @returns {number}
 */
export const getHeight = (element, withoutExtraSpace = true) => {
    // Ensure the element is a DOM element
    if (!(element instanceof Element)) {
        throw new Error("Invalid element provided.");
    }
    // Get the computed style of the element
    const style = window.getComputedStyle(element);
    // Extract the height, padding, and border values
    const height = element.clientHeight; // Includes padding but not border, margin, or scrollbar
    if (withoutExtraSpace) {
        const paddingTop = parseFloat(style.paddingTop);
        const paddingBottom = parseFloat(style.paddingBottom);

        return height - paddingTop - paddingBottom;
    }

    return height;
};

export const handleize = (text) => {
    return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(/[^\w-]+/g, "") // Remove all non-word chars
        .replace(/--+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, ""); // Trim - from end of text
};

export const camelCase = (text) => {
    // Using replace method with regEx
    return text
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        })
        .replace(/\s+/g, "");
};

export const scrollToTop = (selector, height) => {
    let element = typeof selector === "string" ? document.querySelector(selector) : selector;
    let scrollValue = height ? element?.offsetTop - height : element?.offsetTop;
    window.scrollTo({
        top: scrollValue,
        behavior: "smooth",
    });
};

export const hideAndBlockScroll = (selector) => {
    let element = typeof selector === "string" ? document.querySelector(selector) : selector;
    if (!element.classList.contains("hidden-scroll")) {
        element.classList.add("hidden-scroll");
    }
};

export const showAndUnlockScroll = (selector) => {
    let element = typeof selector === "string" ? document.querySelector(selector) : selector;
    if (element.classList.contains("hidden-scroll")) {
        element.classList.remove("hidden-scroll");
    }
};

export const blockScroll = () => {
    document.querySelector("html").classList.add("hidden-scroll");
};

export const unblockScroll = () => {
    document.querySelector("html").classList.remove("hidden-scroll");
};
export const isUserLoggedIn = () => {
    return Shopify.theme_settings.userLoggedIn;
};

export const redirectTo = (url) => {
    window.location.href = url;
};

export const getURLParameter = (param) => {
    let urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has(param)) {
        return false;
    }

    return urlParams.get(param);
};

export const addParameterToUrl = (key, value) => {
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    if (history.state != null && history.state.url === url.href) {
        return;
    }
    window.history.pushState({ url: url.href }, document.title, url.href);
};

export const lcFirst = (string) => {
    return string.charAt(0).toLowerCase() + string.slice(1);
};

export const arrayCompare = (arrayFirst, arraySecond) => {
    if (arrayFirst.length !== arraySecond.length) return false;
    let length = arraySecond.length;
    for (let i = 0; i < length; i++) {
        if (arrayFirst[i] !== arraySecond[i]) return false;
    }

    return true;
};

export const inArray = (needle, haystack) => {
    let length = haystack.length;
    for (let i = 0; i < length; i++) {
        if (typeof haystack[i] === "object") {
            if (arrayCompare(haystack[i], needle)) return true;
        } else {
            if (haystack[i] === needle) return true;
        }
    }
    return false;
};

export const copyToClipboard = (textToCopy, successCallback, errorCallback) => {
    if (!navigator.clipboard) {
        const temp = document.createElement("input");
        temp.type = "text";
        temp.value = textToCopy;
        document.body.appendChild(temp);
        temp.select();
        document.execCommand("Copy");
        document.body.removeChild(temp);
        successCallback();
    } else {
        navigator.clipboard
            .writeText(textToCopy)
            .then(() => {
                successCallback();
            })
            .catch(() => {
                errorCallback();
            });
    }
};

export const delegateTriggerClick = (element) => {
    element.addEventListener("click", (e) => {
        e.preventDefault();
        document.querySelector(element.getAttribute("data-trigger-click"))?.click();
    });
};

export const formDataToObject = (form) => {
    const formData = new FormData(form);
    const obj = {};

    formData.forEach((value, key) => {
        key.split(/\[|\]/)
            .filter(Boolean)
            .reduce((acc, curr, i, arr) => {
                return (acc[curr] = i === arr.length - 1 ? value : acc[curr] || {});
            }, obj);
    });

    return obj;
};

export const formatProductTitle = (title) => {
    return title.split("::")[0];
};

export const objectCopy = (obj) => {
    return JSON.parse(JSON.stringify(obj));
};
